import { useEffect, useState } from 'react'
import { getSpreadsheetData } from './functions'
import Testimonies from './Testimonies'
import style from './App.module.css'

import logo from './images/Amnesty_International_logo.png'

function App() {

	const [data, setData] = useState(undefined)

	useEffect(() => {
		(async function() {
			if (!data) {
				const spreadsheetData = await getSpreadsheetData()
				setData(spreadsheetData)
			}
		}())		
	}, [])

	if (!data) {
		return null
	}

	return (
		<div>
			<div className={style.cta}>
				Extracts from more than 100 interviews with women and girls in Afghanistan.<br/>Names have been changed to protect identities.
				<div className={style.logo}>
					<img src={logo}/>
				</div>
			</div>
			<Testimonies num={4} data={data} />	
		</div>
	)
}

export default App
